<template>
  <ul class="snsRegistButtons">
    <li>
      <Button :label="label" line wide />
    </li>
  </ul>
</template>

<script lang="ts">
import Button from '@/components/elements/Button.vue'

export default {
  name: 'SnsRegistButtons',

  components: {
    Button
  },

  props: {
    label: {
      type: String,
      default: 'LINEでログイン'
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.snsRegistButtons {
  max-width: 336px;
  margin: 15px auto 25px;

  & > li:not(:first-child) {
    margin-top: 15px;
  }
}
</style>
